import { useExperiment } from 'src/hooks/useExperiment'
import { FF_NEW_LANDING_PAGES_REDESIGN } from 'src/constants/feature-flags'

export type LandingPageSections = {
  hero: boolean
  featuredMeals: boolean
  info: boolean
  footer: boolean
}

export function useLandingPageSections(): {
  enabled: boolean
  sections: LandingPageSections
} {
  const { active, payload } = useExperiment(FF_NEW_LANDING_PAGES_REDESIGN)
  const sectionsRaw =
    payload?.type === 'json' && payload.value.sections
      ? payload.value.sections
      : {}
  const sections: LandingPageSections = {
    hero: Boolean(sectionsRaw.hero),
    featuredMeals: Boolean(sectionsRaw.featuredMeals),
    info: Boolean(sectionsRaw.info),
    footer: Boolean(sectionsRaw.footer)
  }
  return { enabled: !!active, sections }
}
